import { render } from "./AssignFund.vue?vue&type=template&id=bc6fc0ea&ts=true"
import script from "./AssignFund.vue?vue&type=script&lang=ts"
export * from "./AssignFund.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__